import { RootState } from 'handlers';

export const getStudentLoanData = ({ studentLoanData }: RootState) => studentLoanData;
